import { render, staticRenderFns } from "./PalletingFilter.vue?vue&type=template&id=32c88da8&scoped=true&"
import script from "./PalletingFilter.vue?vue&type=script&lang=js&"
export * from "./PalletingFilter.vue?vue&type=script&lang=js&"
import style0 from "./PalletingFilter.vue?vue&type=style&index=0&id=32c88da8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32c88da8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VProgressLinear})
